'use client';

import type { TDynamicData } from '@eliadmin/core/src/types/dynamic-data';
import { fetchDynamicSections } from '@eliadmin/core/src/api/dynamics/dynamics-api';
import { useQuery } from '@tanstack/react-query';
import { MemberZoneFile } from '../member-zone-file';
import { FilesSkeleton } from '../files-skeleton';
import { useState } from 'react';

import { Input } from '../../ui/input';

import { CiSearch } from 'react-icons/ci';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function MinutesTab({ locale }: { locale: string }) {
  const [searchTerm, setSearchTerm] = useState('');

  const { t } = useTranslations();

  const { data: files = [], isLoading } = useQuery({
    queryKey: ['MINUTES', locale, searchTerm],
    queryFn: () =>
      fetchDynamicSections<TDynamicData>({
        locale,
        sectionIds: [7],
        query: {
          orderBy: 'id',
          order: 'desc',
          results: 1000,
          search: searchTerm || undefined,
        },
      }),
  });

  return (
    <>
      <div className="grid w-full grid-cols-1 gap-2.5 lg:grid-cols-2">
        <Input
          type="text"
          placeholder={t('text211')}
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          before={<CiSearch size={20} className="ml-4 text-primary" />}
          className={{
            main: 'col-span-1 h-[50px] w-full rounded-full bg-black/5 pl-12 text-sm text-primary placeholder-primary',
            wrapper: 'col-span-1 h-[50px] w-full rounded-full bg-transparent',
          }}
        />
      </div>
      {isLoading ? (
        <FilesSkeleton />
      ) : (
        <div className="flex w-full flex-col items-start justify-start gap-2.5">
          {files.map(file => (
            <MemberZoneFile item={file} key={file.id} showDownload showPrint />
          ))}
        </div>
      )}
    </>
  );
}
